<template>
  <footer>
    <div class="row px-2 px-lg-0 justify-content-center">
      <div class="col-12 bg-light px-lg-0 row  justify-content-between">

        <div class="col-lg-10 row p-0 m-0 mx-auto mt-5 mt-md-0">

          <div class="col-md-6 d-grid">

            <div style="align-self: center">
              <h5 class="text-primary">
                برای اطلاع از محصولات جدید
              </h5>
              <p class="mb-0">
                و اطلاع از تخفیف ها و جشنواره ها لطفا پیج اینستاگرام ما را دنبال کنید
              </p>
            </div>

          </div>

          <div class="col-md-6 d-grid py-4">
            <div style="align-self: center;text-align: left">
              <img src="/img/qr.png" class="img-fluid ms-4 ms-md-5 rounded-5" style="max-width: 150px;" alt="">
              <a target="_blank" href="https://www.instagram.com/mokamel_moo_gisoo/">
                <img src="/img/instalogo.png" class="img-fluid " style="max-width: 150px;" alt="">
              </a>
            </div>

          </div>
        </div>

      </div>
      <div class=" col-12 col-lg-10 pt-5 pb-4">

        <div class="row justify-content-between">
          <div class="col-md-4 d-flex justify-content-between px-4 p-md-0 mb-5 mb-md-0">
            <a href="/profile">حساب کاربری</a>
            <a href="/cart">سبد خرید</a>
            <a href="/contact">ارتباط با ما</a>
          </div>
          <div class="col-md-3 d-flex justify-content-between px-4 p-md-0">
            <a target="_blank" href="https://wa.me/09128222725"><i class="bi bi-whatsapp"></i></a>
            <a target="_blank" href="https://t.me/roxanarahimi"><i class="bi bi-telegram"></i></a>
            <a  href="tel:09128222725"><i class="bi bi-telephone-fill"></i></a>
          </div>
          <div class="col-12 mt-5 d-md-flex justify-content-between px-3 p-md-0">
            <p>&copy; کلیه حقوق این وبسایت متعلق به <span class="text-primary">فروشگاه rx</span> میباشد </p>
            <p>تهیه شده با <i class="bi bi-heart text-primary"></i>
              توسط تیم طراحی و توسعه <a target="_blank" href="https://webagent.ir" class="text-primary">webagent</a></p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
}
</script>

<style scoped>

</style>